import { TimelineMax } from "gsap";
import { SplashText } from "../modules/SplashText";
import { IDimConfig } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../../translations/TranslationConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";

export class SplashViewMultiplier extends BaseView implements SplashView  {
    
    protected _txt:SplashText;
    protected _img:PIXI.Sprite;

    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(1.75, 1.75),
                position: new PIXI.Point(360, 300),
                layout: {
                    left: new PIXI.Point(360, 300),
                    right: new PIXI.Point(360, 300)
                }
            },
            portrait: {
                scale: new PIXI.Point(1.75, 1.75),
                position: new PIXI.Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };
    protected _timeLine:TimelineMax;

    protected DEFAULT_TXT_STYLE:TextStyleOptions;

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
    }

    protected initAnimations():void{
        this._txt = new SplashText(Translation.translate(TranslationConfig.MULTIPLIER_FS),this.DEFAULT_TXT_STYLE);
        this._img = new PIXI.Sprite(GameResources.getTextures("Train_Screens/FS_Multiplier")[0])
        this._img.anchor.set(0.5,0.5);
        this._img.position = new PIXI.Point(360,360);
        this._txt.position = new PIXI.Point(360,160);

        this._txt.anchor.set(0.5,0);

        this.addChild(this._txt);
        this.addChild(this._img);
        this.visible = false;

        StageManager.getLayer(PunkGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    public play():TimelineMax{
        this._timeLine = new TimelineMax();
        this.visible = true;
        return new TimelineMax();
    }

    public stop():TimelineMax{
        this._timeLine = new TimelineMax();
        this.visible = false;
        return this._timeLine;
    }
}
